import { render, staticRenderFns } from "./AdminRegistrationsInfo.vue?vue&type=template&id=6af1ce40"
import script from "./AdminRegistrationsInfo.vue?vue&type=script&lang=js"
export * from "./AdminRegistrationsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports